module.exports = __webpack_public_path__ + "static/media/idun3.637b5bd9.JPG";